import { useOfferLandingPageModel } from '../model/offer/offerModel';
import { useLandingPageViewModel } from './viewModel';

export const useOfferLandingPageViewModel = (p: {
  programId: number;
  creatorId: number;
  offerId: number;
}) => {
  const model = useOfferLandingPageModel(p);
  const vm = useLandingPageViewModel(model);
  return vm;
};
